import styled, { css } from "styled-components";
import { Form, FlexboxGrid, List } from "rsuite";
import Button from "rsuite/es/Button";

import CustomField from "components/Form/CustomField";

export const TrafficLimitForm = styled(Form)`
    && {
        display: flex;
    }

    && .rs-input[disabled], && .rs-picker-select.rs-picker-disabled, && .rs-picker-select.aria-disabled {
        color: inherit;
        background-color: inherit;
        opacity: 0.6;
    }

    && .rs-form-control-wrapper .rs-error-message-placement-top-end .rs-error-message {
        bottom: auto;
        font-size: 10px;
        padding: 0 2px;
        border: none;
        box-shadow: none;
        right: 6px;
        top: -4px;
    }

    &&& .rs-input, &&& .rs-picker-select .rs-btn {
        ${props =>
        props.styleClosed &&
        css`
            background-color: #d3d3d9 !important;
            border-color: #b4b4b4;
        `
    }
    }
`;

export const StyledField = styled.div`
    && {
    }
`;

export const StyledButtonContainer = styled.div``;

export const SaveButton = styled(Button)`
    && {
        margin-right: 10px;
        width: 34px;
        height: 34px;
        padding: 0px;
        border-color: var(--color-secondary) !important;
        color: var(--color-secondary) !important;
    }
`;

export const CancelButton = styled(Button)`
    && {
        width: 34px;
        height: 34px;
        padding: 0px;
        border-color: red !important;
        color: red !important;
    }
`;

export const EditButton = styled(Button)`
    && {
        margin-right: 10px;
        width: 34px;
        height: 34px;
        padding: 0px;
        border-color: var(--color-primary) !important;
        color: var(--color-primary) !important;
    }
`;

export const AddNewButton = styled(Button)`
    margin-top: ${props => props.mt || 0}px;
    margin-left: ${props => props.ml || 34}px;
    margin-bottom: ${props => props.mb || 0}px;
`;

export const StyledListItem = styled(List.Item)`
    && {
        padding-top: 0px;
    }
`;

export const StyledFlexboxGrid = styled(FlexboxGrid)`
    && {
        margin-top: ${props => props.mt !== undefined ? props.mt : 10}px;
        margin-left: ${props => props.ml !== undefined ? props.ml : 80}px;
        margin-bottom: ${props => props.mb !== undefined ? props.mb : 10}px;
    }

    && .rs-flex-box-grid-item-2:not(:last-child) {
        margin-right: 107px;
    }
`;

export const StyledList = styled(List)`
    && {
        box-shadow: none;
        margin-bottom: 10px;
    }

    && .rs-list-item {
        box-shadow: none;
    }

    && .rs-form-control-wrapper {
        padding-right: 20px;
    }

    &&& .rs-list-item .rs-form-group {
        margin-bottom: 0;
        display: flex;
        align-items: center;
    }

    && .rs-list-item .delete {
        display: inline-block;
        position: absolute;
        right: -3px;
        top: 12px;
        cursor: pointer;
        border: 1px black;
        background: white;
        border-radius: 1px;
        width: 15px;
        height: 15px;
    }

    && .rs-list-item .delete_traffic {
        display: inline-block;
        position: absolute;
        margin-left: 5px;
        top: 12px;
        cursor: pointer;
        border: 1px black;
        background: white;
        border-radius: 1px;
        width: 15px;
        height: 15px;
    }
`;

export const StyledLabel = styled.span`
    ${props => props.display === "block" ? css`
        display: block;
    ` : css`
        display: inline-block;
    `}

    ${props => !props.compact && css`
        width: 100%;
    `}

    ${props => props.width && css`
        min-width: ${props.width}px;
        max-width: ${props.width}px;
        width: ${props.width}px;
    `}

    && {
        ${props => props.margin && css`
            margin: ${props.margin};
        `}

        margin-bottom: ${props => props.mb !== undefined ? props.mb : 0}px !important;
        margin-right: ${props => props.mr !== undefined ? props.mr : 0}px !important;
        margin-left: ${props => props.ml !== undefined ? props.ml : 10}px !important;
        margin-top: ${props => props.mt !== undefined ? props.mt : 0}px !important;
    }

    margin-right: 10px;
    margin-bottom: 5px;
`;

export const StyledContainerColumn = styled.div`
    && {
        display: flex;
        flex-direction: column;

        ${props => props.margin && css`
            margin: ${props.margin};
        `}

        margin-bottom: ${props => props.mb !== undefined ? props.mb : 10}px !important;
        margin-right: ${props => props.mr !== undefined ? props.mr : 0}px !important;
        margin-left: ${props => props.ml !== undefined ? props.ml : 0}px !important;
        margin-top: ${props => props.mt !== undefined ? props.mt : 0}px !important;
    }
`;

export const StyledContainerRow = styled.div`
    && {
        display: flex;
        align-items: center;
        flex-direction: row;
        margin-bottom: ${props => props.mb !== undefined ? props.mb : 10}px !important;
        margin-right: ${props => props.mr !== undefined ? props.mr : 0}px !important;
        margin-left: ${props => props.ml !== undefined ? props.ml : 0}px !important;
        margin-top: ${props => props.mt !== undefined ? props.mt : 0}px !important;

        ${props => props.start ? css`
            justify-content: flex-start;
        ` : css`
            justify-content: space-between;
        `}

        ${props => props.maxWidth && css`
            max-width: ${props.maxWidth}px;
        `}
    }
`;

export const StyledGrid = styled(FlexboxGrid)`
    && {
        max-width: 560px;
    }

    ${props => props.isMobile && css`
        &&& {
            flex-direction: column;
        }
    `}

    &&.list-container {
        overflow-y: auto;
        max-height: ${props => props.maxHeight !== undefined ? props.maxHeight : 200}px;
        ${props => props.showBorder && css`
            border: 1px solid lightgray;
            border-radius: 5px;
        `}
        padding: 5px 0px;
    }
`;

export const StyledButton = styled(Button)`
    ${props => !props.withoutMargin && (!props.under ? css`
        margin-top: 10px;
        ${props.open && "margin-bottom: 20px !important"};
    ` : css`
        margin-bottom: 20px !important;
    `)};
    width: 140px;
`;

export const Header = styled.div`
    font-family: Roboto;
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 21px;
    margin-left: ${props => props.ml || 40}px;
    margin-bottom: ${props => props.mb || 10}px !important;
    margin-top: ${props => props.mt || 10}px;
    padding: 0px;
`;

export const CustomPercentField = styled(CustomField)`
    && {
        width: 90px !important;
    }
`;

export const StyledTwoColumnLayout = styled.div`
    display: flex;
    gap: 40px;

    margin-bottom: ${props => props.mb !== undefined ? props.mb : 20}px !important;
    margin-right: ${props => props.mr !== undefined ? props.mr : 0}px !important;
    margin-left: ${props => props.ml !== undefined ? props.ml : 0}px !important;
    margin-top: ${props => props.mt !== undefined ? props.mt : 0}px !important;

    ${props => props.theme?.isMobile && css`
        flex-direction: column;
        gap: 20px;
    `}
`;

export const StyledLeftColumn = styled.div`
    flex: 0 0 auto;
    display: flex;
    flex-direction: column;
    min-width: 700px;
    max-width: 750px;
`;

export const StyledRightColumn = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    min-width: 500px;
`;

export const StyledSingleLineFlexboxGridItem = styled(FlexboxGrid.Item)`
    && {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        width: 100%;

        .title {
            width: ${props => props.width || 200}px;
        }
    }
`;

export const StyledStatusIndexContainer = styled.div`
    display: inline-flex;
    align-items: center;
    width: ${props => props.width !== undefined ? props.width : 70}px;
    flex-shrink: 0;
    justify-content: flex-end;

    .status {
        width: 26px;
        flex-shrink: 0;
        display: inline-flex;
        align-items: center;
        justify-content: center;
    }

    .index {
        background: white;
        color: gray;
        height: 36px;
        width: 34px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
        flex-shrink: 0;
    }
`;

export const StyledMenuItem = styled.div`
    && {
        font-weight: ${props => !props.global ? "bold" : "normal"};
    }
`;

export const TrafficLimitHeader = styled.div`
    display: flex;
    margin-left: 30px;
    margin-bottom: 5px;
    font-weight: 500;
    font-size: 14px;
    color: #575757;
`;

export const TrafficLimitHeaderItem = styled.div`
    min-width: ${props => props.width}px;
    width: ${props => props.width}px;
    padding-left: ${props => props.paddingLeft || 0}px;
`;
